import React, { Component } from 'react';
import Buttons from "../Buttons";
class ModalHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
          buttonList:this.props.buttonList
        }
      }
      componentDidUpdate(prevProps){
        if(prevProps.buttonList !== this.props.buttonList) {
          this.setState({buttonList:this.props.buttonList});
        //   console.log(this.state.buttonList);
        }
    }
    render () {
        return (
            <>
                <h5 className="modal-title secondary_color pl-2" id="staticModalLabel"> 
                {(this.props.Title!==undefined)?this.props.Title:<br></br>}
                    <div className="btn-right">
                        <Buttons buttonList={this.state.buttonList} />
                    </div>
                </h5>
            </>
            
        )
    }
}

export default ModalHeader;